import { useEffect } from 'react';
import { useStores } from '../../stores';
import { getInitialDuration } from '../helper-utils/dateDurationUtils';
import { MonthMap } from '../helper-utils/EditDuration';

export const useInitializeDuration = (
  dateFilterResponse: any,
  isCustomQueryPage?: boolean,
) => {
  const { employerGroupStore, customQueriesStore } = useStores();

  useEffect(() => {
    if (!dateFilterResponse) {
      return;
    }

    const result = getInitialDuration({
      selectedStartDate: employerGroupStore.selectedDuration?.startDate,

      selectedEndDate: employerGroupStore.selectedDuration?.endDate,

      startMonth: dateFilterResponse.start_month,
      startYear: dateFilterResponse.start_year,

      endMonth: dateFilterResponse.end_month,
      endYear: dateFilterResponse.end_year,

      planEndMonth: dateFilterResponse.plan_end_month,
      recentPlanYear: dateFilterResponse.recent_plan_year,

      isCustomQueryPage,
      MonthMap,
    });

    employerGroupStore.setSelectedDuration(
      result.startDate.format('YYYY-MM-DD'),
      result.endDate.format('YYYY-MM-DD'),
    );

    customQueriesStore.setCurrentDates(
      result.startDate.format('YYYY-MM-DD'),
      result.endDate.format('YYYY-MM-DD'),
    );
  }, [dateFilterResponse]);
};
